var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M13.217,0a13.239,13.239,0,0,1,9.346,3.834,13,13,0,0,1,1.717,16.42L30,26.429,26.056,30l-5.517-6.012A13.316,13.316,0,0,1,3.871,22.346a13,13,0,0,1,0-18.512A13.24,13.24,0,0,1,13.217,0Zm8.3,4.867a11.823,11.823,0,0,0-16.606,0,11.55,11.55,0,0,0,0,16.446,11.823,11.823,0,0,0,16.606,0,11.551,11.551,0,0,0,0-16.446Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.adeb1f068fb1933dab97f22872ac2f83.svg";
export { ForwardRef as ReactComponent };